var map = {
	"./Translations.json": [
		499,
		499
	],
	"./de_DE.json": [
		5153,
		534
	],
	"./en-PS.json": [
		450,
		450
	],
	"./en-US.json": [
		8355,
		355
	],
	"./fr_FR.json": [
		7160,
		160
	],
	"./ja_JA.json": [
		394,
		394
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5326;
module.exports = webpackAsyncContext;